import { render } from "./ToolBarMedical.vue?vue&type=template&id=181fd04d"
import script from "./ToolBarMedical.vue?vue&type=script&lang=js"
export * from "./ToolBarMedical.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__